import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LabelComponent} from './components/label/label.component';
import {HintModule} from '@shared/modules/hint/hint.module';


@NgModule({
    declarations: [LabelComponent],
    exports: [
        LabelComponent
    ],
    imports: [
        CommonModule,
        HintModule
    ]
})
export class LabelModule { }
